import {
  Button,
  IconButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText,
  Skeleton
} from '@mui/material'
import { Asset } from '../types'
import { useTranslation } from 'react-i18next'
import AssetProjectEditButton from './AssetProjectEditButton'
import CopyableListItemButton from './CopyableListItemButton'

export interface AssetProjectListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetProjectListItemButton({
  asset,
  editable = false,
  afterUpdate,
  ...props
}: AssetProjectListItemButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('asset')

  return (
    <CopyableListItemButton {...props} copyText={asset.project?.name || ''}>
      <ListItemText
        primary={
          asset?.project ? (
            asset.project.name
          ) : asset.projectId === null ? (
            t('noProject')
          ) : (
            <Skeleton variant="text" width={100} height={20} />
          )
        }
        primaryTypographyProps={{
          color: asset?.projectId === null ? 'text.disabled' : 'inherit'
        }}
        secondary={t('project')}
      />

      {editable && (
        <ListItemSecondaryAction>
          <AssetProjectEditButton
            asset={asset}
            component={asset?.projectId === null ? Button : IconButton}
            variant="outlined"
            afterUpdate={afterUpdate}
          />
        </ListItemSecondaryAction>
      )}
    </CopyableListItemButton>
  )
}
